import React from 'react';
import { Link } from 'react-router-dom';
import { FaMobileAlt } from 'react-icons/fa'; // Using mobile icon for the badge
import imageSocialMedia from "../../../assets/images/imgSocialMedia.jpg";
import './SocialConnectCta.css'; 
import { SOCIAL_FRONTEND_URL } from '../../../config';

const SocialConnectCta = () => {
  return (
    <section className="bs-social-cta-section">
      <div className="bs-container">
        <div className="bs-social-cta-row">
          

          {/*  Column: Content */}
          <div className="bs-social-content-col">
            
            {/* Floating Icon Badge */}
            <div className="bs-social-icon-badge">
              <FaMobileAlt size={24} />
            </div>

            <h2 className="bs-social-title">
              CONNECT<br />
              INSTANTLY WITH<br />
              TRADIES VIA <span className="bs-font-light">OUR<br />
              SOCIAL NETWORK</span>
            </h2>

            <p className="bs-social-desc">
              Post a job and wait for highly rated tradies contact you
            </p>

            <a 
              href={SOCIAL_FRONTEND_URL} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bs-btn-social-blue"
            >
              Connect via Social
            </a>

          </div>


          {/*  Column: Image */}
          <div className="bs-social-image-col">
            <img 
              src={imageSocialMedia} 
              alt="Social Media Connection" 
              className="bs-social-img" 
            />
          </div>


        </div>
      </div>
    </section>
  );
};

export default SocialConnectCta;